export default __webpack_public_path__ + "static/media/search.e2b076ff.svg";